module.exports = __webpack_public_path__ + "img/inactiveip.1902d771.svg";